export default "__VITE_ASSET__kaQqYckb__"